import React, {Fragment, useEffect, useMemo, useState} from "react";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import LoadingSpinner from "../components/LoadingSpinner.js";
import config from "../config";
import { genericErrorMsg } from "../utils.js";
import dayjs from 'dayjs';
import {IoAddOutline} from "react-icons/io5";
import {MdMode, MdDelete} from "react-icons/md";
import ConfirmationModal from "../components/ConfirmationModal.js";
import AddOfflandDatesModal from "../components/AddOfflandDatesModal.js";
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import { Country, State }  from 'country-state-city';

export default function MyBookingInvitationLetterPage() {

  let { bookingId } = useParams();

  useEffect(() => {
  },[])

  const countries = useMemo(() => Country.getAllCountries().map(c=>{ return {value: c.name, label: c.name}}), []);

  const [saving, setSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [fullName, setFullName] = useState('');
  const [passportNumber, setPassportNumber] = useState('');
  const [nationality, setNationality] = useState('');
  const [birthDate, setBirthDate] = useState(null);
  const [residenceAddress, setResidenceAddress] = useState('');
  const [arrivalDate1, setArrivalDate1] = useState(null);
  const [departureDate1, setDepartureDate1] = useState(null);
  const [arrivalDate2, setArrivalDate2] = useState(null);
  const [departureDate2, setDepartureDate2] = useState(null);  

  const [submitted, setSubmitted] = useState(false);
  
  const save = (e) => {
      e.preventDefault();
      const form = document.querySelector('form.invitation-letter-form');
      form.classList.add('was-validated');

      var data = new FormData(form);
      
      if (form.checkValidity()===true) {
          setSaving(true);
          var data = new FormData(form);
          fetch(`${config.server_base_url}/api/my-booking/${bookingId}/invitation-letter`, 
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(Object.fromEntries(data.entries()))
          })
          .then((response) => response.json())
          .then((data) => { if (data.success) {setSubmitted(true);} else {setErrorMsg(data.reason); setSaving(false);} })
          .catch((error) => {setSaving(false); toast.error( genericErrorMsg, {theme: 'colored'})});
      }
      return false;
  }  

  return (
    <div className="app-container my-booking-app">
      <div className="page-container my-booking-page my-booking-invitation-letter-page">  
          {!submitted ?
          <Fragment>
            <h1>Visa Invitation Letter Request Form</h1>
            <center><p className='form-info' style={{maxWidth: '400px'}}><em>Please fill in the form below carefully as these details will be used for your invitation letter.</em></p></center>
            <Form noValidate onSubmit={save} className="invitation-letter-form">
                  {errorMsg ? <p className="error">{errorMsg}</p> : <span></span>}

                  <Form.Group className="mb-3" controlId="fullName">
                    <Form.Label>Full legal name (as it appears on the passport):</Form.Label>
                    <Form.Control
                      type="text"
                      name='fullName'
                      value={fullName}
                      required
                      onChange={(e) => setFullName(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="passportNumber">
                    <Form.Label>Passport number:</Form.Label>
                    <Form.Control
                      type="text"
                      name='passportNumber'
                      value={passportNumber}
                      required
                      onChange={(e) => setPassportNumber(e.target.value)}
                    />
                  </Form.Group>                  

                  <Form.Group className="mb-3" controlId="nationality">
                    <Form.Label>Nationality:</Form.Label>
                    <Form.Select
                      value={nationality}
                      name='nationality'
                      required
                      onChange={(e) => setNationality(e.target.value)}
                    >
                      <option value="">Select a country…</option>
                      {countries.map((c) => (
                        <option key={c.value} value={c.value}>{c.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="birthDate">
                    <Form.Label>Birth date:</Form.Label>
                    <div>
                      <DatePicker
                        name='birthDate'
                        selected={birthDate}
                        required
                        onChange={(date) => setBirthDate(date)}
                        dateFormat="dd MMM, yyyy"
                        calendarStartDay={1}
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={new Date()}
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="residenceAddress">
                    <Form.Label>Residence address:</Form.Label>
                    <Form.Control
                      name='residenceAddress'
                      required
                      as="textarea"
                      rows={2}
                      value={residenceAddress}
                      onChange={(e) => setResidenceAddress(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="arrivalDate1">
                    <Form.Label>Arrival date to Portugal:</Form.Label>
                    <div>
                      <DatePicker
                        name='arrivalDatePortugal'
                        required
                        selected={arrivalDate1}
                        onChange={(date) => setArrivalDate1(date)}
                        dateFormat="dd MMM, yyyy"
                        calendarStartDay={1}
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="departureDate1">
                    <Form.Label>Departure date from Portugal:</Form.Label>
                    <div>
                      <DatePicker
                        name='departureDatePortugal'
                        required
                        selected={departureDate1}
                        onChange={(date) => setDepartureDate1(date)}
                        dateFormat="dd MMM, yyyy"
                        calendarStartDay={1}
                        minDate={arrivalDate1}
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="arrivalDate2">
                    <Form.Label>Arrival date to Monte Sahaja:</Form.Label>
                    <div>
                      <DatePicker
                        name='arrivalDateMonteSahaja'
                        required
                        selected={arrivalDate2}
                        onChange={(date) => setArrivalDate2(date)}
                        dateFormat="dd MMM, yyyy"
                        calendarStartDay={1}
                        minDate={arrivalDate1}
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="departureDate2">
                    <Form.Label>Departure date from Monte Sahaja:</Form.Label>
                    <div>
                      <DatePicker
                        name='departureDateMonteSahaja'
                        required
                        selected={departureDate2}
                        onChange={(date) => setDepartureDate2(date)}
                        dateFormat="dd MMM, yyyy"
                        calendarStartDay={1}
                        minDate={arrivalDate2}
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    </div>
                  </Form.Group>

                  <Button
                    style={{margin: '0 auto', display: 'block'}}
                    variant="primary"
                    type="submit"
                    disabled={saving}
                    onDoubleClick={() => false}
                  >
                    Submit
                  </Button>
            </Form>
          </Fragment> : <p><center>Thank you! We will be in touch with the invitation letter soon.</center></p>}
      </div>
      <ToastContainer />
    </div>
  )
}